import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './registerServiceWorker';
import router from './router';
import store from './store';
import Root from './Root.vue';

const app = createApp(Root);

app.use(ElementPlus)
  .use(store)
  .use(router);

app.mount('#app');

// 关键：AOS 必须在 app.mount() 与 router.isReady() 之后再初始化。
// 预渲染页的静态 HTML 已含 [data-aos] 元素；若在 mount 前 init（原实现），AOS 会对
// 「水合前」的 DOM 计算偏移，水合后状态失效，导致部分元素永久卡在 opacity:0（不可见）。
// SPA 页 init 时 #app 为空、无此问题；挪到 isReady 之后，两种环境行为一致。
router.isReady().then(() => {
  // 移动端：预渲染的 PC 版 #app 在首屏已被 html.ua-mobile 隐藏（见 public/index.html），
  // 此刻水合已完成，移除该类以显示真实的移动端页面，避免「先闪 PC 再切移动端」。
  document.documentElement.classList.remove('ua-mobile');

  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: false, // Allow animations to replay on route change
    mirror: false,
  });
  // 重新收集 [data-aos] 元素并触发视口内元素的动画（首屏元素立即 aos-animate）
  AOS.refreshHard();

  // 路由切换后重算：refreshHard 会重新扫描元素，避免漏触发导致元素卡在隐藏态。
  // 注册在此处（AOS 已 init）以避免首个 afterEach 在 init 前触发 refreshHard。
  router.afterEach(() => {
    setTimeout(() => {
      AOS.refreshHard();
    }, 100); // Small delay to ensure DOM is updated
  });

  // 构建期预渲染信号：等初始路由、AOS 与首屏渲染稳定后派发事件，
  // 供 scripts/prerender.js 捕获完整 DOM（renderAfterDocumentEvent: 'prerender-ready'）。
  // 注意：预渲染渲染器在 document 上监听，故必须派发到 document（window 上派发不会传播到 document）。
  // 对真实用户无副作用（仅一个自定义事件）。
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.dispatchEvent(new Event('prerender-ready'));
    });
  });
});

// 兜底：极慢网络/异常下确保 ua-mobile 类一定被移除，避免移动端永久空白。
setTimeout(() => document.documentElement.classList.remove('ua-mobile'), 1500);
